(function($) {
  'use strict';

  function normalize(value) {
    var text = String(value || '').toLowerCase();
    if (text.normalize) {
      text = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    }
    return text.replace(/[^a-z0-9]+/g, ' ').replace(/^\s+|\s+$/g, '').replace(/\s+/g, ' ');
  }

  function dimensionScore(value) {
    var matches = String(value || '').replace(/,/g, '.').match(/\d+(?:\.\d+)?/g) || [];
    var score = 0;
    $.each(matches, function(_, match) {
      score = Math.max(score, parseFloat(match) || 0);
    });
    return score;
  }

  function isDimensionOption(name) {
    return /\b(?:dimension|dimensiones|dmension|dmensiones|medida|medidas|tamano|tamanos|talla|tallas)\b/.test(normalize(name));
  }

  function isFrameOption(name) {
    return /\b(?:marco|marcos|acabado|acabados|color de marco)\b/.test(normalize(name));
  }

  function isFrameValue(value) {
    return /^(?:dorado|plateado|negro|blanco|madera|madera natural|natural|sin marco)$/.test(normalize(value));
  }

  function isDimensionValue(value) {
    var text = normalize(value);
    return /\b(?:cm|mm|alto|ancho|pulgada|pulgadas|chico|chica|pequeno|pequena|mediano|mediana|grande|small|medium|large)\b/.test(text) || /\d+\s*x\s*\d+/.test(text);
  }

  function optionValues(product, optionIndex) {
    var values = [];
    $.each(product.variants || [], function(_, variant) {
      if (!variant || !variant.options) return;
      var value = String(variant.options[optionIndex] || '');
      if (value && $.inArray(value, values) === -1) values.push(value);
    });
    return values;
  }

  function optionRole(product, optionIndex, optionName) {
    var values = optionValues(product, optionIndex);
    var frameValues = 0;
    var dimensionValues = 0;

    $.each(values, function(_, value) {
      if (isFrameValue(value)) frameValues += 1;
      if (isDimensionValue(value)) dimensionValues += 1;
    });

    // Product data contains swapped names, typos and "Descripcion" labels.
    // Values are the reliable source; names remain a fallback for unusual sets.
    if (values.length && frameValues === values.length) return 'frame';
    if (dimensionValues > 0 && dimensionValues >= frameValues) return 'dimension';
    if (isDimensionOption(optionName)) return 'dimension';
    if (isFrameOption(optionName)) return 'frame';
    return 'other';
  }

  function sortDimensionOptions() {
    $('[data-section-type="product-template"]').each(function() {
      var $container = $(this);
      var sectionId = $container.attr('data-section-id');
      var jsonNode = document.getElementById('ProductJson-' + sectionId);
      if (!jsonNode) return;

      var product;
      try {
        product = JSON.parse(jsonNode.textContent || jsonNode.innerHTML);
      } catch (error) {
        return;
      }

      var optionWrappers = [];

      $.each(product.options || [], function(optionIndex, optionName) {
        var dataIndex = 'option' + (optionIndex + 1);
        var $radios = $container.find('input.single-option-selector__radio[data-index="' + dataIndex + '"]');
        var $selects = $container.find('select.single-option-selector__radio[data-index="' + dataIndex + '"]');
        var $wrapper = $radios.first().closest('[data-g314-option-name]');
        if (!$wrapper.length) $wrapper = $selects.first().closest('[data-g314-option-name]');
        var role = optionRole(product, optionIndex, optionName);

        if ($wrapper.length) {
          var canonicalName = role === 'dimension' ? 'Dimensiones' : role === 'frame' ? 'Marco' : $.trim(optionName);
          $wrapper.attr('data-g314-option-name', canonicalName);
          $wrapper.find('.single-option-radio__label').first().text(canonicalName);
          optionWrappers.push({
            wrapper: $wrapper,
            role: role,
            originalIndex: optionIndex
          });
        }

        if (role !== 'dimension') return;

        function optionPrice(value) {
          var highestPrice = -1;
          $.each(product.variants || [], function(_, variant) {
            if (!variant || !variant.available || !variant.options) return;
            if (String(variant.options[optionIndex]) !== String(value)) return;
            highestPrice = Math.max(highestPrice, parseInt(variant.price, 10) || 0);
          });
          return highestPrice;
        }

        if ($radios.length) {
          var $fieldset = $radios.first().closest('fieldset');
          var pairs = [];
          $radios.each(function() {
            var $input = $(this);
            var inputId = $input.attr('id');
            var $label = $fieldset.children('label').filter(function() {
              return $(this).attr('for') === inputId;
            }).first();
            pairs.push({
              input: $input.detach(),
              label: $label.detach(),
              price: optionPrice($input.val()),
              score: dimensionScore($input.val())
            });
          });
          pairs.sort(function(a, b) {
            if (a.price !== b.price) return b.price - a.price;
            return b.score - a.score;
          });
          $.each(pairs, function(_, pair) {
            $fieldset.append(pair.input).append(pair.label);
          });
        }

        $selects.each(function() {
          var $select = $(this);
          var options = $select.children('option').detach().get();
          options.sort(function(a, b) {
            var priceDifference = optionPrice($(b).val()) - optionPrice($(a).val());
            if (priceDifference) return priceDifference;
            return dimensionScore($(b).val()) - dimensionScore($(a).val());
          });
          $select.append(options);
        });
      });

      var $variantSelect = $container.find('select.product-single__variants').first();
      if ($variantSelect.length && optionWrappers.length > 1) {
        optionWrappers.sort(function(a, b) {
          var rank = { dimension: 0, frame: 1, other: 2 };
          var roleDifference = rank[a.role] - rank[b.role];
          return roleDifference || a.originalIndex - b.originalIndex;
        });
        $.each(optionWrappers, function(_, option) {
          option.wrapper.insertBefore($variantSelect);
        });
      }
    });
  }

  function money(cents) {
    return theme.Currency.formatMoney(cents, theme.strings.moneyFormat);
  }

  function setFactsFromTitle(title) {
    var text = normalize(title);
    var match = text.match(/\bset(?: de)? ([2-8])\b/) || text.match(/\b([2-8]) piezas\b/);
    var count = match ? parseInt(match[1], 10) : 0;
    if (!count && /\btriptico\b/.test(text)) count = 3;
    if (!count && /\bdiptico\b/.test(text)) count = 2;
    if (!count && /\bcuadruple\b/.test(text)) count = 4;
    return { isSet: /\bset\b|\bdiptico\b|\btriptico\b|\bcuadruple\b/.test(text), count: count };
  }

  function contextFromTitle(title) {
    var text = normalize(title);
    var contexts = [
      ['recamara', 'Recámara'],
      ['sala', 'Sala'],
      ['comedor', 'Comedor'],
      ['credenza', 'Credenza'],
      ['estudio', 'Estudio'],
      ['oficina', 'Oficina']
    ];
    for (var i = 0; i < contexts.length; i++) {
      if (new RegExp('\\b' + contexts[i][0] + '\\b').test(text)) return contexts[i][1];
    }
    return null;
  }

  function productData($container) {
    var sectionId = $container.attr('data-section-id');
    var jsonNode = document.getElementById('ProductJson-' + sectionId);
    if (!jsonNode) return null;
    try {
      return JSON.parse(jsonNode.textContent || jsonNode.innerHTML);
    } catch (error) {
      return null;
    }
  }

  function updateTriptychSummary($container, variant) {
    var $summary = $container.find('[data-g314-triptych-summary]');
    if (!$summary.length || !variant) return;

    var product = productData($container);
    if (!product) return;

    var dimension = '';
    $.each(product.options || [], function(optionIndex, optionName) {
      if (dimension || optionRole(product, optionIndex, optionName) !== 'dimension') return;
      dimension = String((variant.options || [])[optionIndex] || '');
    });

    var dimensionNumbers = String(dimension || '').replace(/,/g, '.').match(/\d+(?:\.\d+)?/g) || [];
    var is120x80 = dimensionNumbers.length >= 2
      && parseFloat(dimensionNumbers[0]) === 120
      && parseFloat(dimensionNumbers[1]) === 80;
    $summary.find('[data-g314-triptych-dimension]').text(dimension);
    $summary.find('[data-g314-triptych-footprint]')
      .prop('hidden', !is120x80);
  }

  function updateVariantFacts($container, variant) {
    var $discountBadges = $container.find('[data-g314-discount-badge]');
    var hasDiscount = Boolean(variant && variant.compare_at_price > variant.price);
    var discountPercent = hasDiscount
      ? Math.round((variant.compare_at_price - variant.price) * 100 / variant.compare_at_price)
      : 0;

    $discountBadges
      .text(hasDiscount ? discountPercent + '% menos' : '')
      .prop('hidden', !hasDiscount);

    if (!variant) {
      $container.find('[data-g314-saving]').text('').prop('hidden', true);
      return;
    }

    var isSet = $container.find('[data-g314-property-set]').val() === 'true';
    var saving = isSet && variant.compare_at_price > variant.price
      ? variant.compare_at_price - variant.price
      : 0;
    $container.find('[data-g314-saving]').each(function() {
      $(this)
        .text(saving > 0 ? 'Ahorra ' + money(saving) + ' sobre precio regular' : '')
        .prop('hidden', saving <= 0);
    });
    updateTriptychSummary($container, variant);
  }

  function initContextCarousel($root, labels) {
    var $viewport = $root.find('[data-g314-context-viewport]');
    var viewport = $viewport.get(0);
    var track = $root.find('[data-g314-context-track]').get(0);
    var $items = $(track).children();
    var $previous = $root.find('[data-g314-context-previous]');
    var $next = $root.find('[data-g314-context-next]');
    var $controls = $root.find('[data-g314-context-controls]');
    var $indicators = $root.find('[data-g314-context-indicators]').empty();
    var $status = $root.find('[data-g314-context-status]');
    var itemCount = $items.length;
    var activeIndex = 0;
    var ticking = false;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function clampIndex(index) {
      return Math.max(0, Math.min(itemCount - 1, index));
    }

    function isScrollable() {
      return itemCount > 1 && viewport.scrollWidth - viewport.clientWidth > 4;
    }

    function itemLeft(index) {
      var item = $items.get(clampIndex(index));
      return item ? item.offsetLeft - track.offsetLeft : 0;
    }

    function updateState(index, announce) {
      activeIndex = clampIndex(index);
      $previous.prop('disabled', activeIndex === 0);
      $next.prop('disabled', activeIndex === itemCount - 1);
      $indicators.children().each(function(dotIndex) {
        $(this).attr('aria-current', dotIndex === activeIndex ? 'true' : 'false');
      });
      if (announce) {
        $status.text('Espacio ' + labels[activeIndex] + ', ' + (activeIndex + 1) + ' de ' + itemCount);
      }
    }

    function syncControls() {
      var scrollable = isScrollable();
      $controls.prop('hidden', !scrollable);
      $indicators.prop('hidden', !scrollable);
      if (!scrollable) {
        activeIndex = 0;
        $previous.prop('disabled', true);
        $next.prop('disabled', true);
        $indicators.children().attr('aria-current', 'false').first().attr('aria-current', 'true');
      }
      return scrollable;
    }

    function closestIndex() {
      var nearest = 0;
      var distance = Infinity;
      $items.each(function(index) {
        var candidate = Math.abs(itemLeft(index) - viewport.scrollLeft);
        if (candidate < distance) {
          distance = candidate;
          nearest = index;
        }
      });
      return nearest;
    }

    function goTo(index, announce) {
      if (!isScrollable()) {
        viewport.scrollLeft = 0;
        updateState(0, announce);
        syncControls();
        return;
      }
      var nextIndex = clampIndex(index);
      var options = {
        left: itemLeft(nextIndex),
        behavior: reducedMotion ? 'auto' : 'smooth'
      };
      if (viewport.scrollTo) {
        viewport.scrollTo(options);
      } else {
        viewport.scrollLeft = options.left;
      }
      updateState(nextIndex, announce);
    }

    $.each(labels, function(index, label) {
      $('<button/>', {
        type: 'button',
        'class': 'g314-contexts__indicator',
        'aria-label': 'Ver ' + label
      }).attr('data-g314-context-index', index).appendTo($indicators);
    });

    $previous.on('click.g314', function() {
      goTo(activeIndex - 1, true);
    });
    $next.on('click.g314', function() {
      goTo(activeIndex + 1, true);
    });
    $indicators.on('click.g314', '[data-g314-context-index]', function() {
      goTo(parseInt($(this).attr('data-g314-context-index'), 10) || 0, true);
    });
    $viewport.on('keydown.g314', function(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      goTo(activeIndex + (event.key === 'ArrowRight' ? 1 : -1), true);
    });
    $viewport.on('scroll.g314', function() {
      if (ticking) return;
      ticking = true;
      var updateAfterScroll = function() {
        updateState(closestIndex(), false);
        ticking = false;
      };
      if (window.requestAnimationFrame) {
        window.requestAnimationFrame(updateAfterScroll);
      } else {
        window.setTimeout(updateAfterScroll, 16);
      }
    });
    $(window).on('resize.g314Contexts', function() {
      updateState(closestIndex(), false);
      syncControls();
    });

    updateState(0, false);
    syncControls();
  }

  function localContextMedia($root) {
    var sectionId = $root.closest('[data-section-type="product-template"]').attr('data-section-id');
    var jsonNode = document.getElementById('ContextMediaJson-' + sectionId);
    if (!jsonNode) return [];

    try {
      return JSON.parse(jsonNode.textContent || jsonNode.innerHTML) || [];
    } catch (error) {
      return [];
    }
  }

  function renderContextItems($root, items, model) {
    var labels = [];
    var images = {};
    var $track = $root.find('[data-g314-context-track]').empty();

    $.each(items || [], function(index, item) {
      if (!item || !item.image || labels.length >= 6) return;
      var imageKey = String(item.image).split('?')[0];
      if (images[imageKey]) return;
      images[imageKey] = true;

      var label = item.label || contextFromTitle(item.alt) || 'Ambiente ' + (labels.length + 1);
      var imageWidth = parseInt(item.imageWidth, 10) || 480;
      var imageHeight = parseInt(item.imageHeight, 10) || 360;
      var $item = $('<li/>', { 'class': 'g314-contexts__item' });
      var $card;

      if (item.url) {
        $card = $('<a/>', {
          'class': 'g314-contexts__card',
          href: String(item.url).split('?')[0],
          'aria-label': 'Ver ' + (model || 'este modelo') + ' para ' + label
        });
      } else {
        $card = $('<span/>', { 'class': 'g314-contexts__card' });
      }

      var $media = $('<span/>', { 'class': 'g314-contexts__media' }).appendTo($card);
      $('<img/>', {
        src: item.image,
        alt: item.alt || '',
        loading: 'lazy',
        decoding: 'async'
      }).attr({
        width: imageWidth,
        height: imageHeight
      }).appendTo($media);

      $('<span/>', {
        'class': 'g314-contexts__label',
        text: label
      }).appendTo($card);

      $item.append($card).appendTo($track);
      labels.push(label);
    });

    if (!labels.length) return false;
    $root.prop('hidden', false);
    initContextCarousel($root, labels);
    return true;
  }

  function loadContextCarousel() {
    $('[data-g314-contexts]').each(function() {
      var $root = $(this);
      if ($root.data('g314ContextsLoading')) return;
      $root.data('g314ContextsLoading', true);

      var model = $.trim($root.attr('data-model') || '');
      var currentId = String($root.attr('data-current-product-id') || '');
      var currentTitle = $root.attr('data-current-title') || '';
      var currentIsSet = $root.attr('data-is-set') === 'true';
      var currentCount = parseInt($root.attr('data-piece-count'), 10) || 0;
      var modelKey = normalize(model);
      var localMedia = localContextMedia($root);
      var reliableModel = modelKey && /\d/.test(modelKey) && normalize(currentTitle).indexOf(modelKey) !== -1;

      if (!reliableModel || (currentIsSet && currentCount <= 0)) {
        renderContextItems($root, localMedia, model);
        return;
      }

      $.getJSON('/search', {
        q: model,
        type: 'product',
        view: 'g314-contexts'
      }).done(function(payload) {
        var products = payload && payload.products ? payload.products : [];
        var cards = {};
        var currentPath = window.location.pathname.replace(/\/$/, '');

        $.each(products, function(_, product) {
          var cleanUrl = String(product.url || '').split('?')[0];
          var hasPieceCount = product.pieceCount !== undefined && product.pieceCount !== null && product.pieceCount !== '';
          var resultCount = hasPieceCount ? parseInt(product.pieceCount, 10) : setFactsFromTitle(product.title).count;
          if (isNaN(resultCount)) resultCount = 0;
          var resultFacts = {
            isSet: Boolean(product.isSet),
            count: resultCount
          };
          var context = contextFromTitle(product.title);
          var isCurrentProduct = currentId
            ? String(product.id) === currentId
            : cleanUrl.replace(/\/$/, '') === currentPath;

          if (!context || !cleanUrl || isCurrentProduct || !product.image) return;
          if (normalize(product.model) !== modelKey) return;
          if (normalize(product.title).indexOf(modelKey) === -1) return;
          if (currentIsSet !== resultFacts.isSet) return;
          if (currentIsSet && resultFacts.count !== currentCount) return;
          if (!cards[context]) cards[context] = product;
        });

        var items = [];
        var order = ['Sala', 'Comedor', 'Recámara', 'Credenza', 'Estudio', 'Oficina'];
        $.each(order, function(_, label) {
          var product = cards[label];
          if (!product) return;
          items.push({
            label: label,
            url: product.url,
            image: product.image,
            alt: product.imageAlt || product.title || '',
            imageWidth: product.imageWidth,
            imageHeight: product.imageHeight
          });
        });

        renderContextItems($root, items.concat(localMedia), model);
      }).fail(function() {
        renderContextItems($root, localMedia, model);
      });
    });
  }

  function initScrollCarousel($root) {
    if ($root.data('g314CarouselReady')) return;
    var $viewport = $root.find('[data-g314-carousel-viewport]');
    var $track = $root.find('[data-g314-carousel-track]');
    var $items = $root.find('[data-g314-carousel-item]');
    var $previous = $root.find('[data-g314-carousel-previous]');
    var $next = $root.find('[data-g314-carousel-next]');
    var $status = $root.find('[data-g314-carousel-status]');
    var viewport = $viewport.get(0);
    var track = $track.get(0);
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var ticking = false;
    if (!viewport || !track || !$items.length) return;

    $root.data('g314CarouselReady', true);

    function itemLeft(index) {
      var item = $items.get(Math.max(0, Math.min($items.length - 1, index)));
      return item ? item.offsetLeft - track.offsetLeft : 0;
    }

    function closestIndex() {
      var nearest = 0;
      var distance = Infinity;
      $items.each(function(index) {
        var candidate = Math.abs(itemLeft(index) - viewport.scrollLeft);
        if (candidate < distance) {
          distance = candidate;
          nearest = index;
        }
      });
      return nearest;
    }

    function update(announce) {
      var activeIndex = closestIndex();
      var maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth - 2);
      $previous.prop('disabled', viewport.scrollLeft <= 2);
      $next.prop('disabled', viewport.scrollLeft >= maxScroll);
      if (announce) {
        $status.text('Elemento ' + (activeIndex + 1) + ' de ' + $items.length);
      }
    }

    function go(direction) {
      var nextIndex = Math.max(0, Math.min($items.length - 1, closestIndex() + direction));
      if (viewport.scrollTo) {
        viewport.scrollTo({ left: itemLeft(nextIndex), behavior: reducedMotion ? 'auto' : 'smooth' });
      } else {
        viewport.scrollLeft = itemLeft(nextIndex);
      }
      update(true);
    }

    $previous.on('click.g314', function() { go(-1); });
    $next.on('click.g314', function() { go(1); });
    $viewport.on('keydown.g314', function(event) {
      if (event.key !== 'ArrowLeft' && event.key !== 'ArrowRight') return;
      event.preventDefault();
      go(event.key === 'ArrowRight' ? 1 : -1);
    });
    $viewport.on('scroll.g314', function() {
      if (ticking) return;
      ticking = true;
      (window.requestAnimationFrame || window.setTimeout)(function() {
        update(false);
        ticking = false;
      });
    });
    $(window).on('resize.g314HomeCarousel', function() { update(false); });
    update(false);
  }

  function initProductThumbnails($root) {
    if ($root.data('g314ThumbnailsReady')) return;
    var $viewport = $root.find('[data-g314-thumbnails-viewport]');
    var $track = $root.find('[data-g314-thumbnails-track]');
    var $images = $root.find('[data-g314-thumb-src]');
    var $items = $root.find('[data-g314-thumbnail-item]');
    var $section = $root.closest('[data-section-type="product-template"]');
    var $mediaGroup = $section.find('[data-product-single-media-group]');
    var viewport = $viewport.get(0);
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!viewport || !$track.length) return;

    $root.data('g314ThumbnailsReady', true);

    function loadImage(image) {
      var $image = $(image);
      var source = $image.attr('data-g314-thumb-src');
      if (!source) return;
      $image.attr('src', source).removeAttr('data-g314-thumb-src');
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function(entries) {
        $.each(entries, function(_, entry) {
          if (!entry.isIntersecting) return;
          loadImage(entry.target);
          observer.unobserve(entry.target);
        });
      }, { root: viewport, threshold: 0.01 });
      $images.each(function() { observer.observe(this); });
    } else {
      $images.slice(0, 6).each(function() { loadImage(this); });
    }

    function showThumbnail(index, immediate) {
      var item = $items.get(index);
      if (!item) return;
      var itemStart = item.offsetLeft;
      var itemEnd = itemStart + item.offsetWidth;
      var viewportStart = viewport.scrollLeft;
      var viewportEnd = viewportStart + viewport.clientWidth;
      if (itemStart >= viewportStart && itemEnd <= viewportEnd) return;
      var target = Math.max(0, itemStart - (viewport.clientWidth - item.offsetWidth) / 2);
      if (viewport.scrollTo) {
        viewport.scrollTo({
          left: target,
          behavior: immediate || reducedMotion ? 'auto' : 'smooth'
        });
      } else {
        viewport.scrollLeft = target;
      }
    }

    $mediaGroup
      .off('afterChange.g314ProductThumbs')
      .on('afterChange.g314ProductThumbs', function(event, slick, currentSlide) {
        showThumbnail(currentSlide, false);
      });

    var initialIndex = $items.index($items.find('.active-thumb').closest('[data-g314-thumbnail-item]'));
    showThumbnail(Math.max(0, initialIndex), true);
  }

  function initReveal() {
    var $targets = $('[data-g314-reveal]:not(.g314-is-visible)');
    if (!$targets.length) return;
    var reducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reducedMotion || !('IntersectionObserver' in window)) {
      $targets.addClass('g314-is-visible');
      return;
    }

    document.documentElement.className += ' g314-reveal-enabled';
    var observer = new IntersectionObserver(function(entries) {
      $.each(entries, function(_, entry) {
        if (!entry.isIntersecting) return;
        $(entry.target).addClass('g314-is-visible');
        observer.unobserve(entry.target);
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    $targets.each(function() { observer.observe(this); });
  }

  function renderDrawerInsights(cart) {
    var hasSet = false;
    var models = {};

    $.each(cart.items || [], function(_, item) {
      var properties = item.properties || {};
      var isSet = String(properties._g314_is_set) === 'true';
      var model = $.trim(properties._g314_model || '');
      if (isSet) {
        hasSet = true;
      } else if (model) {
        var key = normalize(model);
        models[key] = models[key] || { label: model, quantity: 0 };
        models[key].quantity += item.quantity;
      }
    });

    var nudge = null;
    $.each(models, function(_, entry) {
      if (!nudge && entry.quantity === 2) nudge = entry;
    });

    $('.g314-cart-insights--drawer').remove();
    if (!hasSet && !nudge) return;

    var $box = $('<aside/>', {
      'class': 'g314-cart-insights g314-cart-insights--drawer',
      'aria-label': 'Ventajas de tu selección'
    });
    if (hasSet) {
      $('<p/>').text('Tu carrito incluye un set curado.').appendTo($box);
    }
    if (nudge) {
      var $nudge = $('<p/>').text('Tienes 2 piezas del modelo ' + nudge.label + '. ');
      $('<a/>', {
        href: '/search?type=product&q=' + encodeURIComponent(nudge.label),
        text: 'Explora una composición de 3 piezas'
      }).appendTo($nudge);
      $nudge.append('.').appendTo($box);
    }
    $('.ajaxcart__inner').append($box);
  }

  function initFirstOrderPromo() {
    var $promo = $('[data-g314-first-order-promo]').first();
    if (!$promo.length || $promo.data('g314PromoReady')) return;
    $promo.data('g314PromoReady', true);

    var storageKey = 'g314-first-order-promo-v1';
    var previouslySeen = false;
    try {
      previouslySeen = window.localStorage.getItem(storageKey) === 'seen';
    } catch (error) {}
    if (previouslySeen) return;

    var lastFocus = null;

    function rememberSeen() {
      try {
        window.localStorage.setItem(storageKey, 'seen');
      } catch (error) {}
    }

    function closePromo() {
      rememberSeen();
      $promo.prop('hidden', true);
      $('body').removeClass('g314-promo-open');
      $(document).off('keydown.g314FirstOrderPromo');
      if (lastFocus && lastFocus.focus) lastFocus.focus();
    }

    function openPromo() {
      lastFocus = document.activeElement;
      $promo.prop('hidden', false);
      $('body').addClass('g314-promo-open');
      $promo.find('[data-g314-promo-apply]').first().focus();
      $(document).on('keydown.g314FirstOrderPromo', function(event) {
        if (event.key === 'Escape') closePromo();
      });
    }

    $promo.on('click.g314FirstOrderPromo', '[data-g314-promo-close]', closePromo);
    $promo.on('click.g314FirstOrderPromo', '[data-g314-promo-apply]', rememberSeen);
    window.setTimeout(openPromo, 900);
  }

  $(document).on('variantChange.g314', '[data-section-type="product-template"]', function(event) {
    updateVariantFacts($(this), event.variant);
  });

  $(document).on('change.g314FramePreview', '[data-g314-option-name] .single-option-selector__radio', function() {
    var $option = $(this).closest('[data-g314-option-name]');
    if (!isFrameOption($option.attr('data-g314-option-name'))) return;
    if (!window.matchMedia || !window.matchMedia('(max-width: 768px)').matches) return;

    var $section = $option.closest('[data-section-type="product-template"]');
    var $gallery = $section.find('[data-product-single-media-group]').first();
    if (!$gallery.length) return;

    window.setTimeout(function() {
      var target = Math.max(0, $gallery.offset().top - 12);
      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      if (reducedMotion) {
        window.scrollTo(0, target);
      } else {
        $('html, body').stop(true).animate({ scrollTop: target }, 300);
      }
    }, 120);
  });

  $(document.body).on('ajaxCart.afterCartLoad.g314', function(_, cart) {
    renderDrawerInsights(cart);
  });

  sortDimensionOptions();

  $(function() {
    $('[data-section-type="product-template"]').each(function() {
      var $container = $(this);
      var selectedVariantId = String($container.find('select.product-single__variants').first().val() || '');
      var product = productData($container);
      var selectedVariant = null;
      $.each(product && product.variants || [], function(_, variant) {
        if (!selectedVariant && String(variant.id) === selectedVariantId) selectedVariant = variant;
      });
      updateTriptychSummary($container, selectedVariant);
    });
    loadContextCarousel();
    $('[data-g314-carousel]').each(function() { initScrollCarousel($(this)); });
    $('[data-g314-product-thumbnails]').each(function() { initProductThumbnails($(this)); });
    initFirstOrderPromo();
    initReveal();
  });

  $(document).on('shopify:section:load.g314', function(event) {
    var $section = $(event.target);
    loadContextCarousel();
    $section.find('[data-g314-carousel]').each(function() { initScrollCarousel($(this)); });
    $section.find('[data-g314-product-thumbnails]').each(function() { initProductThumbnails($(this)); });
    sortDimensionOptions();
    initReveal();
  });
})(jQuery);
